import { useTheme } from 'styled-components'

import { Padding } from '@/@bothrs-ui/web/components/layout'
import { Span } from '@/@bothrs-ui/web/components/typography/Body'
import { StSectionTitle } from './TimelineEmptyMonth.styled'

type Props = {
  sectionTitle: string
}

const TimelineEmptyMonth = ({ sectionTitle }: Props) => {
  const theme = useTheme()

  return (
    <>
      <StSectionTitle>{sectionTitle}</StSectionTitle>
      <Padding pb={theme.UI.Spacing.Space3}>
        <Span type='BodyMediumRegular' color={theme.Colors.Neutrals.Darker}>
          Niets gepland deze maand
        </Span>
      </Padding>
    </>
  )
}

export { TimelineEmptyMonth }
